import { images } from "../../../../Assets/assetsHelper";
import "./CategoryDetails.css";
import { BarLoader } from "react-spinners";
import { useNavigate } from "react-router";
import { display } from "@mui/system";
import { Box, Grid, Typography } from "@mui/material";
import PrimaryButton from "../../../../Components/Atoms/Buttons/Primary/PrimaryButton";
import AddAwardForm from "../../../../Components/Organisms/Forms/AddAwardForm/AddAwardForm";
import FormModal from "../../../../Components/Molecules/FormModal/FormModal";

function CategoryDetails({
  loading,
  category,
  ageGroups,
  awards,
  Open,
  setOpen,
  setAwards,
}) {
  const navigate = useNavigate();
  return (
    <div className="mainContainer">
      {/* <FormModal
        Open={Open}
        HandleClose={() => {
          setOpen(false);
        }}
        Form={
          <AddAwardForm
            Open={Open}
            setOpen={setOpen}
            id={category?.id}
            setAwards={setAwards}
          />
        }
        Title={"Add New Award"}
      /> */}
      {category && !loading ? (
        <div className="Cont">
          <h2 style={{ fontSize: "30px", margin: "0 0 10px 0" }}>
            Category Name: {category.name}
          </h2>
          {/* <Box
            sx={{
              width: "100%",
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              marginBottom: "20px",
            }}
          >
            <h2 style={{ margin: "0 0 0 20px" }}>Special Awards:</h2>
            <PrimaryButton
              classBtn={"center"}
              text={"Add New Award"}
              style={{
                textTransform: "capitalize",
                borderRadius: "5px",
                color: "var(--text-secondary)",
                backgroundColor: "var(--primary)",
                height: "40px",
                padding: "0 15px",
                minWidth: "100px",
                textWrap: "noWrap",
              }}
              click={() => setOpen(true)}
            />
          </Box>
          <Box
            sx={{
              display: "flex",
              justifyContent: { xs: "center", md: "flex-start" },
              flexWrap: "wrap",
              cursor: "pointer",
            }}
          >
            {awards?.map((item) => (
              <Box
                className="greyBoxWhite"
                sx={{
                  marginRight: { xs: "0", md: "20px" },
                  width: { xs: "100%", md: "auto" },
                }}
              >
                <div className="greyNumberBox">
                  <div>
                    <h4>Award's Name: </h4>
                    <h3>{item?.award}</h3>
                  </div>
                </div>
              </Box>
            ))}
          </Box> */}
          <h2 style={{ margin: "0 0 20px 0" }}>Age Groups:</h2>
          <Grid container spacing={2}>
            {ageGroups?.map((item) => (
              <Grid item xs={12} md={6} lg={4}>
                <Box className="missionInfoSection">
                  <div className="missionSettingsHeader">
                    <h3 className="missionSettingsTitle">{item?.name}</h3>
                  </div>
                  <Grid container spacing={1}>
                    {/* Age Range */}
                    <Grid item xs={12} sm={6}>
                      <Box className="missionInfoItem">
                        <Typography
                          variant="body2"
                          sx={{
                            color: "#6b7280",
                            fontSize: "12px",
                            marginBottom: "4px",
                            fontWeight: 500,
                          }}
                        >
                          Min Age
                        </Typography>
                        <Typography
                          variant="h6"
                          sx={{
                            color: "var(--text-primary)",
                            fontWeight: 600,
                            fontSize: "18px",
                          }}
                        >
                          {item?.minAge || "-"}
                        </Typography>
                      </Box>
                    </Grid>
                    <Grid item xs={12} sm={6}>
                      <Box className="missionInfoItem">
                        <Typography
                          variant="body2"
                          sx={{
                            color: "#6b7280",
                            fontSize: "12px",
                            marginBottom: "4px",
                            fontWeight: 500,
                          }}
                        >
                          Max Age
                        </Typography>
                        <Typography
                          variant="h6"
                          sx={{
                            color: "var(--text-primary)",
                            fontWeight: 600,
                            fontSize: "18px",
                          }}
                        >
                          {item?.maxAge || "-"}
                        </Typography>
                      </Box>
                    </Grid>
                    <Grid item xs={12} sm={6}>
                      <Box className="missionInfoItem">
                        <Typography
                          variant="body2"
                          sx={{
                            color: "#6b7280",
                            fontSize: "12px",
                            marginBottom: "4px",
                            fontWeight: 500,
                          }}
                        >
                          Min Birthday
                        </Typography>
                        <Typography
                          variant="body1"
                          sx={{
                            color: "var(--text-primary)",
                            fontWeight: 500,
                            fontSize: "15px",
                          }}
                        >
                          {item?.minBirthday?.split("T")?.at(0) || "-"}
                        </Typography>
                      </Box>
                    </Grid>
                    <Grid item xs={12} sm={6}>
                      <Box className="missionInfoItem">
                        <Typography
                          variant="body2"
                          sx={{
                            color: "#6b7280",
                            fontSize: "12px",
                            marginBottom: "4px",
                            fontWeight: 500,
                          }}
                        >
                          Max Birthday
                        </Typography>
                        <Typography
                          variant="body1"
                          sx={{
                            color: "var(--text-primary)",
                            fontWeight: 500,
                            fontSize: "15px",
                          }}
                        >
                          {item?.maxBirthday?.split("T")?.at(0) || "-"}
                        </Typography>
                      </Box>
                    </Grid>
                  </Grid>
                  <Box
                    sx={{
                      width: "100%",
                      display: "flex",
                      justifyContent: "center",
                      marginTop: "12px",
                    }}
                  >
                    <PrimaryButton
                      classBtn={"center"}
                      text={"See More"}
                      style={{
                        textTransform: "capitalize",
                        borderRadius: "5px",
                        color: "var(--text-secondary)",
                        backgroundColor: "var(--primary)",
                        height: "35px",
                        padding: "0 10px",
                        minWidth: "100px",
                        textWrap: "noWrap",
                      }}
                      click={() =>
                        navigate(
                          `/categories/${category?.id}/ageGroups/${item?.id}`
                        )
                      }
                    />
                  </Box>
                </Box>
              </Grid>
            ))}
          </Grid>
        </div>
      ) : (
        <div className="loadingBox">
          <BarLoader color="var(--primary)" />
        </div>
      )}
    </div>
  );
}

export default CategoryDetails;
